import { Metamodel } from '../base/model';
import { irTypesConst } from '../../integrationruntime/integrationruntime.constants';
import { ManagedIntegrationRuntime } from './managed.integrationRuntime';
import { SharedModel } from '../sharedmodel';

@Metamodel.model({
    name: irTypesConst.Airflow
})

export class AirflowIntegrationRuntime extends ManagedIntegrationRuntime {
    // airflow-specific additions
    public airflowVersion?: string;
    public airflowWebUrl?: string;
    public computeSize?: string;
    public extraNodes?: number;
    public enableAutoscale?: boolean;
    public autoScaleMinNodes?: number;
    public autoScaleMaxNodes?: number;
    public clusterIP?: string;
    public airflowEnvironmentVariables?: { [name: string]: string };
    public airflowConfigurationOverrides?: { [name: string]: string };
    public environmentVariables?: { [name: string]: string };
    public airflowRequirements?: string[];
    public enableAADIntegration?: boolean;
    public enableTriggerers?: boolean;
    public userName?: string;
    public password?: string;
    public airflowEntityReferences?: SharedModel.AirflowEntityReference[];
    public packageProviderPath?: string;
    public encryptedSecrets?: SharedModel.AirflowAksEncryptedSecret[];
    public secrets?: SharedModel.AirflowAksSecret[];
    public gitSyncProperties?: SharedModel.AirflowGitSyncProperties;
    public migratedToFabric?: boolean;

    constructor(name?: string, description?: string) {
        super(name, description);
    }
}
